module.exports = __webpack_public_path__ + "static/img/huan-zai-jin-3.498f8e2.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/huan-zai-jin-3.jpeg
// module id = nXUL
// module chunks = 1